import { validateName } from 'utils/validators/name'
import { formatBEError } from 'utils/helpers/BEError'
import { errorTypes } from 'utils/enums/errorTypes'
import { validateEmail, validateRepeatEmail } from 'utils/validators/email'
import { validatePassword, validateRepeatPasswordField } from 'utils/validators/password'

export const createAccountFormConfig = {
  firstName: {
    validator: validateName,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0001, errorTypes.ACCOUNT_0009],
    isRequired: true,
  },
  lastName: {
    validator: validateName,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0003, errorTypes.ACCOUNT_0009],
    isRequired: true,
  },
  middleName: {
    validator: validateName,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0002],
  },
  email: {
    validator: validateEmail,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0004, errorTypes.ACCOUNT_0008, errorTypes.ACCOUNT_0009],
    isRequired: true,
  },
  verifyEmail: {
    validator: validateRepeatEmail,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0005, errorTypes.ACCOUNT_0009],
    isRequired: true,
  },
  password: {
    validator: validatePassword,
    responseValidator: formatBEError,
    responseErrorCodes: [
      errorTypes.ACCOUNT_0006,
      errorTypes.ACCOUNT_0009,
      errorTypes.PASSWORD_0001,
      errorTypes.PASSWORD_0002,
      errorTypes.PASSWORD_0003,
      errorTypes.PASSWORD_0004,
      errorTypes.PASSWORD_0005,
      errorTypes.PASSWORD_0006,
      errorTypes.PASSWORD_0007,
    ],
    isRequired: true,
  },
  verifyPassword: {
    validator: validateRepeatPasswordField,
    responseValidator: formatBEError,
    responseErrorCodes: [errorTypes.ACCOUNT_0007, errorTypes.ACCOUNT_0009],
    isRequired: true,
  },
  privacyPolicy: {
    validator: (formFields, { value }) => (value ? '' : 'Privacy Policy should be checked'),
    isRequired: true,
    value: false,
  },
}
